export default "__VITE_ASSET__CO6HlaSq__"